import thunkMiddleware from 'redux-thunk'
import { combineReducers } from 'redux-immutable'
import { createStore, applyMiddleware, compose } from 'redux'
// import throttle from 'lodash/throttle';
// import { loadState, saveState } from '../util/localStorage'
import rootReducer from './modules/reducer'
import reducerRegistry from './reducerRegistry'
import {sentryEnabled} from '../util/sentry'
import Raven from 'raven-js'
import createRavenMiddleware from 'raven-for-redux'
import Immutable, {Map} from 'immutable'

const configureStore = () => {
  //const persistedState = loadState();
  let middleWares = applyMiddleware(
    thunkMiddleware, // lets us dispatch() functions
  )
  if (sentryEnabled) {
    middleWares = applyMiddleware(
      thunkMiddleware, // lets us dispatch() functions
      createRavenMiddleware(Raven, {  //captures errors into Sentry/Raven
        filterBreadcrumbActions: action => {
          if (action.type === 'expii/ui/TOGGLE_SEARCH_IS_FOCUSED' || action.type === 'expii/ui/TOGGLE_NAV_DROPDOWN' || action.type === 'expii/ui/ENABLE_NAV_SEARCH') {
            return false
          }
          return true
        },
        actionTransformer: action => {
          let newAction = Object.assign({}, action)

          //Entities are huge, so only send the IDs
          if (Object.prototype.hasOwnProperty.call(newAction,'entities')) {
            for (let key in newAction.entities) {
              newAction.entities[key] = Object.keys(newAction.entities[key])
            }
          }
          if (Object.prototype.hasOwnProperty.call(newAction,'payload') 
            && Object.prototype.hasOwnProperty.call(newAction.payload,'entities')) {
            for (let key in newAction.payload.entities) {
              newAction.payload.entities[key] = Object.keys(newAction.payload.entities[key])
            }
          }
          return newAction
        },
        stateTransformer: state => {
          //TODO: transform state so it is a reasonable size for sentry.
          return {}
        },
        getUserContext: state => (state.hasIn(['session','user','id']) ? state.getIn(['session','user']).toJS() : undefined)
      })
    )
  }
  let composedFunctions = compose(
    middleWares
  )

  if (process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION__) { // If not production, add redux_dev_tools
    composedFunctions = compose(
      middleWares,
      window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__({
        serialize: {
          immutable: Immutable
        }
      })
    )
  }


  const initialState = Map()

  const combine = (reducers) => {
    const reducerNames = Object.keys(reducers)
    for (let item of initialState.keys()) {
      if (reducerNames.indexOf(item) === -1) {
        reducers[item] = (state = null) => state
      }
    }
    return combineReducers(reducers)
  }
  const reducer = combine(reducerRegistry.getReducers())
  let store = createStore(
    reducer,
    initialState,
    composedFunctions
  )

  reducerRegistry.setChangeListener(reducers => {
    store.replaceReducer(combine(reducers))
  })

  return store
}

export default configureStore



// WEBPACK FOOTER //
// ./src/redux/configureStore.js